// pages/MassEmailingDashboard.js
import React, { useEffect, useState } from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import EmailBroadcastsDashboard from "./EmailBroadcastsDashboard";
import CreateEmailCampaignModal from "./CreateEmailCampaignModal";
import SeasonalCampaignPanel from "../components/massEmail/SeasonalCampaignPanel";
import SeasonalCampaignModal from "./SeasonalCampaignModal";

export default function MassEmailingDashboard({ intelligenceAudienceId = null, onIntelligenceAudienceConsumed }) {
  const [open, setOpen] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [pendingIntelligenceId, setPendingIntelligenceId] = useState(null);

  const [seasonalOccasion, setSeasonalOccasion] = useState(null);
  const [seasonalOpen, setSeasonalOpen]         = useState(false);

  useEffect(() => {
    if (!intelligenceAudienceId) return;
    setPendingIntelligenceId(intelligenceAudienceId);
    setOpen(true);
    onIntelligenceAudienceConsumed?.();
  }, [intelligenceAudienceId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{ p: 2 }}>
      {/* ✅ Sticky header so New Campaign is always visible */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          bgcolor: "background.default",
          pb: 2,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 0 }}
          flexWrap="wrap"
          gap={2}
        >
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 900 }}>
              Mass Emailing
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              Manage and schedule bulk email campaigns
            </Typography>
          </Box>

          <Stack direction="row" spacing={1} alignItems="center">
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={() => setReloadKey((k) => k + 1)}
              sx={{ textTransform: "none", fontWeight: 800 }}
            >
              Refresh
            </Button>


          </Stack>
        </Stack>
      </Box>

      {/* Seasonal opportunities strip */}
      <SeasonalCampaignPanel
        onLaunch={(occasion) => { setSeasonalOccasion(occasion); setSeasonalOpen(true); }}
      />

      {/* Dashboard content */}
      <EmailBroadcastsDashboard
        key={reloadKey}
        // optional: lets child trigger the same modal if needed
        onNewCampaign={() => setOpen(true)}
        // optional: tells child it's embedded so it can reduce padding/header
        embedded
      />

      {/* Builder embedded INSIDE mass emailing */}
      <CreateEmailCampaignModal
        open={open}
        onClose={() => { setOpen(false); setPendingIntelligenceId(null); }}
        onSuccess={() => {
          setOpen(false);
          setPendingIntelligenceId(null);
          setReloadKey((k) => k + 1);
        }}
        intelligenceAudienceId={pendingIntelligenceId}
      />

      {/* Seasonal campaign modal */}
      <SeasonalCampaignModal
        open={seasonalOpen}
        occasion={seasonalOccasion}
        onClose={() => setSeasonalOpen(false)}
        onSuccess={() => { setSeasonalOpen(false); setReloadKey((k) => k + 1); }}
      />
    </Box>
  );
}
